export const GALLERY_INTERACTIVE_ATTR = 'data-gallery-interactive'

export const galleryInteractiveSelector = `[${GALLERY_INTERACTIVE_ATTR}]`

const compareSliderSelector = '[data-rcs="root"], [data-rcs="handle-root"], [data-rcs="handle"]'

export function isGalleryInteractiveTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false

  return Boolean(
    target.closest(galleryInteractiveSelector) || target.closest(compareSliderSelector),
  )
}
